import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface StoreInOutDetailDto {
  // Keep flexible because backend DTO fields may evolve
  [key: string]: any;
  transactionDate?: string;
  storeId?: number;
  storeName?: string;
  itemId?: number;
  itemCode?: string;
  itemName?: string;
  categoryName?: string;
  transactionType?: string; // IN / OUT
  quantity?: number;
  availableQuantity?: number;
  available_quantity?: number;
  uom?: string;
  referenceType?: string;
  referenceNo?: string;
  heatNo?: string;
  remarks?: string;
}

class StoreInOutReportApiService extends BaseApiService {
  async getStoreInOutDetails(params: {
    branchId: number;
    storeId?: number;
    startDate?: string; // ISO_LOCAL_DATE_TIME (e.g. 2026-07-01T00:00:00)
    endDate?: string;   // ISO_LOCAL_DATE_TIME (e.g. 2026-07-09T23:59:59)
    categoryName?: string;
  }): Promise<ApiResponse<StoreInOutDetailDto[]>> {
    try {
      const q = new URLSearchParams();
      q.append('branchId', String(params.branchId));
      if (params.storeId != null) q.append('storeId', String(params.storeId));
      if (params.startDate) q.append('startDate', params.startDate);
      if (params.endDate) q.append('endDate', params.endDate);
      if (params.categoryName) q.append('categoryName', params.categoryName);

      const response = await this.makeRequest<ApiResponse<StoreInOutDetailDto[]>>(
        `${API_ENDPOINTS.INVENTORY_REPORTS.STORE_IN_OUT_DETAILS}?${q.toString()}`,
        { method: HTTP_METHODS.GET }
      );

      if (response?.success) {
        return {
          success: true,
          message: response.message || 'Store IN/OUT details retrieved successfully',
          data: Array.isArray(response.data) ? response.data : [],
        };
      }

      return {
        success: false,
        message: response?.message || 'Failed to load Store IN/OUT report',
        data: [],
      };
    } catch (error) {
      toast.error('Failed to load Store IN/OUT report');
      throw error;
    }
  }
}

export const storeInOutReportApiService = new StoreInOutReportApiService();

